import { StatusPillVariant } from '../../../../shared/ui/status-pill/status-pill.component';
import { SummaryRealStateInvestmentModel } from './summary-real-state-investment.model';
import { investmentPaymentLabel, investmentPaymentVariant } from '../../shared/investment-payment-status.util';
import { roundAmount } from '../../../../shared/round-amount';

export type RealStateInvestmentRow = SummaryRealStateInvestmentModel & { __expanded?: boolean; __selected?: boolean };

export interface RealStateInvestmentFormDialogData {
  uid?: string;
}

export interface RealStateInvestmentAccountLookup {
  number: string;
  name: string;
}

export interface RealStateInvestmentProviderLookup {
  uid: string;
  companyName: string;
}

export interface RealStateInvestmentFormLookups {
  accounts: RealStateInvestmentAccountLookup[];
  providers: RealStateInvestmentProviderLookup[];
}

export const REAL_STATE_USAGE_OPTIONS: { id: number; display: string }[] = [
  { id: 1, display: 'Desarrollo - Negocio' },
  { id: 2, display: 'Alquiler' },
  { id: 3, display: 'Propiedad' },
  { id: 4, display: 'Bien en especie' },
];

export const REAL_STATE_DEFAULT_COEFFICIENT = 3;
export const REAL_STATE_DEFAULT_PERIOD = 68;

export function realStateUsageLabel(value: number): string {
  const option = REAL_STATE_USAGE_OPTIONS.find(item => item.id === Number(value));
  return option ? option.display : 'Sin uso';
}

export function roundMoney(value: number): number {
  return roundAmount(value);
}

export function realStateTotal(base: number, taxes: { taxImport: number }[]): number {
  const amount = Number(base) || 0;
  const taxAmount = (taxes || []).reduce((acc, tax) => acc + amount * ((Number(tax.taxImport) || 0) / 100), 0);
  return roundMoney(amount + taxAmount);
}

export function realStatePaidVariant(row: SummaryRealStateInvestmentModel): StatusPillVariant {
  return investmentPaymentVariant(row ? { total: row.total, paid: row.totalPaid, pending: row.pending } : null);
}

export function realStatePaidLabel(row: SummaryRealStateInvestmentModel): string {
  return investmentPaymentLabel(row ? { total: row.total, paid: row.totalPaid, pending: row.pending, paidDate: row.lastDepositDate } : null);
}
